import React from "react";
import { Button, ListGroup, ListGroupItem, Popover, PopoverBody, PopoverHeader } from "reactstrap";

import { Block, State } from "../types";
import { getReferencesConfidenceClasses } from "./getConfidenceClass";

type Props = Readonly<{
  block: Block;
  confidenceThreshold: State["confidenceThreshold"];
  onClickReference: (refId: string) => void;
  onCloseReferences: () => void;
  values: State["values"];
  zoneId: string;
}>;

const ReferencesComponent = ({
  block,
  confidenceThreshold,
  onClickReference,
  onCloseReferences,
  values,
  zoneId,
}: Props) => {
  if (block.references.length < 0) {
    return null;
  }
  const referencesConfidenceClass = getReferencesConfidenceClasses(
    block,
    confidenceThreshold,
    values,
  );
  return (
    <Popover popperClassName="references" placement="auto" isOpen target={zoneId}>
      <PopoverHeader className="d-flex align-items-center justify-content-between">
        Data Points <Button close onClick={onCloseReferences} />
      </PopoverHeader>
      <PopoverBody className="p-0">
        <ListGroup flush>
          {block.references.map((r, i) => (
            <ListGroupItem
              className={referencesConfidenceClass[r] || ""}
              href="#"
              key={r}
              onClick={e => {
                e.preventDefault();
                onClickReference(r);
              }}
              tag="a"
              title={r}
            >
              {i + 1}. {r}
            </ListGroupItem>
          ))}
        </ListGroup>
      </PopoverBody>
    </Popover>
  );
};
ReferencesComponent.displayName = "References";
export const References = React.memo(ReferencesComponent);
